import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'fancian-community-data-source';
const CHANGE_EVENT = 'community-data-source-change';

export const DATA_SOURCE_MOCK = 'mock';
export const DATA_SOURCE_API = 'api';

export function getCommunityDataSource() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === DATA_SOURCE_API || stored === DATA_SOURCE_MOCK) return stored;
  } catch {
    // ignore
  }
  const env = process.env.REACT_APP_COMMUNITY_DATA_SOURCE;
  if (env === DATA_SOURCE_API) return DATA_SOURCE_API;
  return DATA_SOURCE_MOCK;
}

export function setCommunityDataSource(source) {
  window.localStorage.setItem(STORAGE_KEY, source);
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: source }));
}

function subscribe(callback) {
  window.addEventListener(CHANGE_EVENT, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(CHANGE_EVENT, callback);
    window.removeEventListener('storage', callback);
  };
}

/**
 * Reactive accessor for the community data source. Components using this hook
 * re-render (and React Query refetches via the data-source query key) the moment
 * the Mock/API toggle changes, without needing to remount the page.
 */
export function useCommunityDataSource() {
  return useSyncExternalStore(subscribe, getCommunityDataSource, getCommunityDataSource);
}
